import axios from "axios";
import { getDeviceId } from "./deviceId";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Country-independent: the backend stores coordinates and leaves country/locality
// to review. Nothing here assumes a market.
export const COMMUNITY_KINDS = [
  { key: "free_parking", label: "Free parking" },
  { key: "paid_parking", label: "Paid parking" },
  { key: "residents_only", label: "Residents only" },
  { key: "loading_bay", label: "Loading zone" },
  { key: "other_restriction", label: "No parking / other" },
];

export async function sendPlaceFeedback(placeId, vote, extra = {}) {  const { data } = await axios.post(
    `${API}/parking-places/${placeId}/feedback`,
    { vote, ...extra },
    { headers: { "X-Device-Id": getDeviceId() } }
  );
  return data;
}

/** One-shot GPS fix sent with a vote, so the backend can tell whether the
 *  driver was actually at the place. Never blocks the vote. */
export function votePosition() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve({});
    const done = (v) => resolve(v);
    const t = setTimeout(() => done({}), 4000);
    navigator.geolocation.getCurrentPosition(
      (p) => {
        clearTimeout(t);
        done({ lat: p.coords.latitude, lng: p.coords.longitude, acc: p.coords.accuracy });
      },
      () => {
        clearTimeout(t);
        done({});
      },
      { enableHighAccuracy: true, timeout: 4000, maximumAge: 30000 }
    );
  });
}

export async function reportPlace(body) {
  const { data } = await axios.post(`${API}/parking-places/report`, body, {
    headers: { "X-Device-Id": getDeviceId() },
  });
  return data;
}

/** "Checked 2 h ago" / "Never checked by drivers" — locale-independent units. */
export function lastCheckedLabel(community) {
  const iso = community?.last_checked_at;
  if (!iso) return "Not checked by drivers yet";
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `Checked ${mins || 1} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 48) return `Checked ${hours} h ago`;
  return `Checked ${Math.round(hours / 24)} days ago`;
}

const VOTES_KEY = "spotdrop_place_votes_v1";

export function myVote(placeId) {
  try {
    return JSON.parse(localStorage.getItem(VOTES_KEY) || "{}")[placeId] || null;
  } catch {
    return null;
  }
}

export function rememberVote(placeId, vote) {
  try {
    const all = JSON.parse(localStorage.getItem(VOTES_KEY) || "{}");
    all[placeId] = vote;
    localStorage.setItem(VOTES_KEY, JSON.stringify(all));
  } catch {
    /* ignore */
  }
}
